export enum role {
  none = 0,
  admin = 1,
  clientManager = 2,
  respondent = 3,
  champion = 4,
  clientAdmin = 5
}
